(function () {
  function pad(n) { return String(n).padStart(2, '0'); }

  function resolveEnd(el) {
    var attr = el.dataset.goPromoEnd;
    if (attr) {
      var ts = parseInt(attr, 10);
      if (!isNaN(ts) && ts > 0) return new Date(ts * 1000);
    }
    var promo = window.GO_PROMO;
    if (promo && promo.endISO) {
      var d = new Date(promo.endISO);
      if (!isNaN(d.getTime())) return d;
    }
    return null;
  }

  function formatRemaining(end) {
    var diff = end - Date.now();
    if (diff <= 0) return null;
    var s   = Math.floor(diff / 1000);
    var d   = Math.floor(s / 86400);
    var h   = Math.floor((s % 86400) / 3600);
    var m   = Math.floor((s % 3600) / 60);
    var sec = s % 60;
    return (d > 0 ? d + 'd ' : '') + pad(h) + ':' + pad(m) + ':' + pad(sec);
  }

  var promo = window.GO_PROMO;
  if (promo) {
    if (promo.bgColor)   document.documentElement.style.setProperty('--go-promo-bg',   promo.bgColor);
    if (promo.textColor) document.documentElement.style.setProperty('--go-promo-text', promo.textColor);
  }

  var elements = document.querySelectorAll('[data-go-promo-card], [data-go-promo-pdp]');

  elements.forEach(function (el) {
    var end = resolveEnd(el);
    if (!end || end <= Date.now()) return;

    el.removeAttribute('hidden');

    if (promo && promo.title && !el.dataset.goPromoEnd) {
      var titleEl = el.querySelector('[data-go-promo-title]');
      if (titleEl) titleEl.textContent = promo.title;
    }

    var timer = el.querySelector('[data-go-promo-timer]');
    if (timer) timer.textContent = formatRemaining(end) || '--:--:--';

    var interval = setInterval(function () {
      var t = formatRemaining(end);
      if (!t) {
        el.setAttribute('hidden', '');
        clearInterval(interval);
        return;
      }
      if (timer) timer.textContent = t;
    }, 1000);
  });
})();
